import styled from 'styled-components';

export const Main = styled.main`
	padding: 80px 0 0 0;
	height: 100vh;
`;
